(function () {
	'use strict';
	angular.module('app.setup')
		.service('userFactoryTableRenderService', userFactoryTableRenderService);

	userFactoryTableRenderService.$inject = ['$rootScope', '$filter', '$translate', 'URLS', 'siteUrl', 'currencyFormatService', 'integerFormatService',
		'leanFilterService', 'percentageFormatService', 'numberFormatService', 'projectRenderService', '$experiments', 'shortageCriticalityLevelService',
		'deliveryPerformanceTypeService', 'siteService'];

	function userFactoryTableRenderService($rootScope, $filter, $translate, URLS, siteUrl, currencyFormatService, integerFormatService,
			leanFilterService, percentageFormatService, numberFormatService, projectRenderService, $experiments, shortageCriticalityLevelService,
			deliveryPerformanceTypeService, siteService) {
		
		var factRollupFields = {
			'isWorkbenchSupervisor': 'isWorkbenchSupervisorRollup'
		};

		var service = {
			checkboxRenderer: checkboxRenderer,
			profileTypeRenderer: profileTypeRenderer,
			roleRenderer: roleRenderer,
			supplierRenderer: supplierRenderer,
			metricEntryRenderer: metricEntryRenderer,
			emailFreqRenderer: emailFreqRenderer,
			factoryNameRenderer: factoryNameRenderer,
			yesNoRenderer: yesNoRenderer,
			customerNameRenderer: customerNameRenderer,
			adminYesNoRenderer: adminYesNoRenderer,
			canCreateSupplierUserRenderer: canCreateSupplierUserRenderer,
			isLeanOnlyRenderer: isLeanOnlyRenderer,
			readOnlyTextRenderer: readOnlyTextRenderer,
			factRollupFields: factRollupFields
		};

		return service;

		// Use this only in tandem with additional authorization rules, like "canEditCell()"
		function canEditCellForSelf(userNdx) {
			return $rootScope.authz.isSuperAdmin() || globalConfig.user.id != userNdx;
		}

		function canEditCell(row, allowUser, internalAdminsOnly) {
			if (internalAdminsOnly) {
				return siteService.isLeanDNAAdminForSite(row.leanDirFactoryNdx);
			} else {
				// Super admin can do anything
				if ($rootScope.authz.isSuperAdmin())
					return true;

				// Other users can't touch a super admin account
				if (row.profileType == 'SuperSystemAdministrator')
					return false;

				// customer admin can do anything after this
				if ($rootScope.authz.isCustomerAdmin()) {
					return true;
				}

				// regular admin cannot edit customer admin
				if (row.isCustomerAdministrator) {
					return false;
				}

				// Admin can do anything after this (if an admin at that site)
				if (row.leanDirFactoryNdx && siteService.isAdminForSite(row.leanDirFactoryNdx))
					return true;

				// Users can edit based on the caller's parameter
				return allowUser;
			}
		}

		function editableContent(row, col, val, clickFunction) {
			return '<div class="cell-div inline-edit-cell"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text" ng-binding title="' + val + '" ' + clickFunction + '>' +
					'<div class="name-field">' + val + '</div>' +
					'<div class="inlineActionIcons" id="actionIcons">' +
						'<i class="fa fa-pencil" title="Click to edit" ' + clickFunction + '></i>' +
					'</div>' +
				'</div > ' +
			'</div>';
		}

		function checkboxRenderer(row, col, rowIndex, params) {
			if (row.isRollup && !row.isCustomerAdministrator) {
				return '<div class="cell-div"></div>';
			}
			var selected = row[col.id];
			var icon = selected ? 'fa fa-fw fa-check-square' : 'fa fa-fw fa-square-o';
			return '<div class="cell-div cell-align-center"><a href ng-click="vm.toggleCheckboxRow(' + rowIndex + ',\'' + col.id + '\')"><i class="' + icon + '"></i></a></div>';

		}

		function profileTypeRenderer(row, col, rowIndex, params) {
			var userNdx = params['userNdx'];
			var val = row.leanDirFactoryNdx || !row.isCustomerAdministrator ? row['profileTypeDisplay'] : 'Company Administrator';
			var supplier = row.roleType === 'Supplier';
			if (canEditCell(row, false) && canEditCellForSelf(userNdx) && !supplier && !row.isRollup && !row.isCustomerAdministrator) {
				var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'profileTypeDisplay', 'profileType'" + ')"';
				return editableContent(row, col, val, clickFunction) ;
			}
			return '<div class="cell-div" title="' + val + '" >' + val + '</div>';
		}

		function roleRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var display = row.roleTypeDisplay;
			if (!$rootScope.authz.isAdmin() && val == 'Supplier')
				val += ' (' + row.supplierName + ')';
			if (canEditCell(row, false) && row.isRollup && !row.allInactive) {
				var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'name', 'roleType'" + ')"';
				return editableContent(row, col, display, clickFunction);
			}
			return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function canCreateSupplierUserRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var display = 'No';
			var isSupplier = row.roleType === 'Supplier';
			if (val) {
				display = 'Yes';
			}
			if (!isSupplier && canEditCell(row, col.allowUser, col.internalAdminsOnly) && row.isRollup && !row.allInactive) {
				var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'display', 'value', true" + ')"';
				return editableContent(row, col, display, clickFunction);
			}
			return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function isLeanOnlyRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var display = 'No';
			if (val) {
				display = 'Yes';
			}
			if (canEditCell(row, col.allowUser, col.internalAdminsOnly) && row.isRollup && !row.allInactive && row.roleType !== 'Supplier') {
				var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'display', 'value', true" + ')"';
				return editableContent(row, col, display, clickFunction);
			}
			return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function supplierRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var display = val;
			if (!val || row.roleType !== 'Supplier') {
				display = '';
			} else {
				display = row.supplierName + ' : ' + row.supplierCode;
			}
			return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function yesNoRenderer(row, col, rowIndex, params) {
			var val = row.isRollup && factRollupFields[col.id] ? row[factRollupFields[col.id]] : row[col.id];
			var display = 'No';
			if (val === 1) {
				display = 'Yes';
			} else if (val === -1) {
				display = 'Mixed';
			}
			
			var canEdit = canEditCell(row, col.allowUser, col.internalAdminsOnly);
			if (col.id !== 'isSmeCertified') {
				canEdit = canEdit && row.roleType !== 'Supplier';
			} 
			var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'display', 'value', true" + ')"';
			if (row.isRollup) {
				if (factRollupFields[col.id]) {
					return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
				}
				canEdit &= (row.isCustomerAdministrator || row.profileType === 'SuperSystemAdministrator');
				return canEdit ? editableContent(row, col, display, clickFunction) : '<div class="cell-div"></div>';
			}
			return canEdit ? editableContent(row, col, display, clickFunction) : '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function adminYesNoRenderer(row, col, rowIndex, params) {
			if (row.isCustomerAdministrator || row.profileType === 'SuperSystemAdministrator' || row.profileType === 'SystemAdministrator') {
				return '<div class="cell-div" title="Yes" >Yes</div>';
			} else {
				return yesNoRenderer(row, col, rowIndex, params);
			}
		}

		function metricEntryRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var display = val ? 'All' : (col.isTarget ? 'None' : 'Assigned');
			if (row.isRollup) display = '';
			var supplier = row.roleType === 'Supplier';
			if (canEditCell(row, col.allowUser) && !supplier && !row.isRollup) {;
				var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'display', 'value', true" + ')"';
				return editableContent(row, col, display, clickFunction);
			}
			return '<div class="cell-div" title="' + display + '" >' + display + '</div>';
		}

		function emailFreqRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var canEdit = canEditCell(row, true);
			var clickFunction = 'ng-click="vm.startEditSelectForUserFactory(' + "'" + col.id + "', " + rowIndex + ", 'display', 'display'" + ')"';
			if (row.isRollup) {
				canEdit &= (row.isCustomerAdministrator || row.profileType === 'SuperSystemAdministrator');
				return canEdit ? editableContent(row, col, val, clickFunction) : '<div class="cell-div"></div>';
			}
			return canEdit ? editableContent(row, col, val, clickFunction) : '<div class="cell-div" title="' + val + '" >' + val + '</div>';
		}

		function factoryNameRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			var state = row.state;
			var extraNameClass = '';
			var extraText = '';
			if (state === 'inactive') {
				extraNameClass = 'linethrough';
				extraText = '<span> (inactive)</span>';
			}
			return '<div class="cell-div" title="' + val + '" ><span class="' + extraNameClass + '">' + val + '</span>' + extraText + '</div>';

		}

		function customerNameRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function readOnlyTextRenderer(row, col, rowIndex, params) {
			var val = row[col.id] || '';
			return '<div class="cell-div" title="' + val + '" >' + val + '</div>';
		}
	}
})();
